import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { SnackBarService } from '../../shared-services/services/snack-bar.service';

@Injectable({
    providedIn: 'root'
})
export class TicketGuard  {
    constructor(
        private router: Router,
        private snackbarService: SnackBarService) { }

    /**
     * Make sure there's a ticket key parameter before spending effort to load route
     */
    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (route.queryParams['key']) {
            return true;
        } else {
            this.snackbarService.openErrorSnackbar('You must provide a key to go to this page.');
            this.router.navigate(['login']);

            return false;
        }
    }
}
